import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import {
    IOfferEventEnrollmentManageable,
    IOfferEventSubscriptionStatus,
} from 'graphql/types';
import { InfoRow } from 'common/components/InfoRow';
import { Text } from 'common/components/Text';

interface IProps {
    subscription?: Partial<IOfferEventEnrollmentManageable>;
    waitingList?: boolean;
}

export const SubscriptionStatusInfo = ({
    subscription,
    waitingList,
}: IProps) => {
    const [translate] = useTranslation();

    if (!subscription) return null;

    const { reason, status } = subscription;

    if (!waitingList && status === IOfferEventSubscriptionStatus.Full) {
        return null;
    }

    let labelTransKey;
    let showReason = false;

    switch (status) {
        case IOfferEventSubscriptionStatus.Enrolled:
            labelTransKey = 'enrolled';

            break;
        case IOfferEventSubscriptionStatus.Requested:
            labelTransKey = 'requested';

            break;
        case IOfferEventSubscriptionStatus.Denied:
            labelTransKey = 'denied';
            showReason = true;

            break;
        case IOfferEventSubscriptionStatus.Full:
            labelTransKey = 'full';

            break;
        case IOfferEventSubscriptionStatus.Completed:
            labelTransKey = 'completed';
            showReason = true;

            if (!!subscription.hasCertificate) {
                labelTransKey = 'completedWithCertificate';
            }

            break;
        case IOfferEventSubscriptionStatus.Absent:
            labelTransKey = 'absent';
            showReason = true;

            break;
    }

    // Only show when we have a status label
    if (!labelTransKey) return null;

    return (
        <InfoRow description={translate('status')}>
            <Box>
                {translate(`offerEventSubscriptionStatus.${labelTransKey}`)}
            </Box>

            {showReason && reason && <Text>{reason}</Text>}
        </InfoRow>
    );
};
